'use strict';

import versioner from '../versioner';
import process from './process';

versioner['ug_pump_station_after_hours'] = {
	process: process,
}

const MODULE_NAME = 'daupler.incidents.versions.ug';

export default MODULE_NAME;
